import { useSetupApp } from 'components/Layouts/hooks/useSetupApp';
import { useAuth } from 'components/providers/AuthProvider';
import { Navigate, Outlet, useLocation } from 'react-router';

export const ProtectedLayout = () => {
  const { loading } = useSetupApp();
  const location = useLocation();
  const { session } = useAuth();

  if (loading) return null;

  // The user is not logged in
  if (!session) {
    return <Navigate to="/auth/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};
